import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import FullHeightCenter from './FullHeightCenter';

export default function LoadingPage({full = true}) {
    const load = <CircularProgress />
    if(full) return (<FullHeightCenter>{load}</FullHeightCenter>)
    return load
}